import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";

const LoginInputForm = styled(FormControl)({
    "& label.Mui-focused": {
        color: "#405289",
        fontSize: 16,
        top: "3px",
    },
    "& label": {
        color: "#586A84",
        fontSize: 16,
        top: "1px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: "6px",
    },
    "& label.MuiFormLabel-filled.MuiInputLabel-shrink": {
        color: "#586A84",
        fontSize: 16,
        top: "3px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#405289",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#405289",
    },
    "& .MuiOutlinedInput-root": {
        "&:hover fieldset": {
            borderColor: "#405289",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#405289",
        },
    },
    "& .MuiFormLabel-root": {
        lineHeight: "16px",
    },
});

export default LoginInputForm;
